import React, { useState, useEffect } from 'react';
import Skeleton from 'components/skeleton/Skeleton';
import styles from './levelUp.module.scss';
import levelHeaderStyles from '../levelHeader/levelHeader.module.scss';
import { useAppSelector } from 'store/hooks';

const SkeletonLevelUp: React.FC = () => {
  const { levels } = useAppSelector((state) => state.level);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200,
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= 768;

  const headerLength = levels.length || 6;

  const cardWidth = isMobile ? 90 : 120;
  const cardHeight = isMobile ? 110 : 140;

  const maxCarouselWidth = Math.min(900, windowWidth - 32);
  const carouselLength = Math.max(3, Math.floor(maxCarouselWidth / (cardWidth + 16)));

  return (
    <div className={styles.levelUpContainer}>
      <div className={styles.headerScrollArea}>
        <div className={levelHeaderStyles.desktopHeaderRow}>
          {Array.from({ length: headerLength }).map((_, idx) => (
            <Skeleton
              key={idx}
              variant="rectangular"
              className={levelHeaderStyles.headerCell}
              animation="pulse"
              style={{
                cursor: 'default',
                border: 'none',
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
              }}
            />
          ))}
        </div>
      </div>
      <div className={styles.wagerContainer}>
        {Array.from({ length: 4 }).map((_, idx) => (
          <Skeleton
            key={idx}
            variant="rectangular"
            className={styles.levelWager}
            height={32}
            animation="pulse"
            style={{
              cursor: 'default',
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              border: 'none',
            }}
          />
        ))}
      </div>
      <div className={styles.carouselSection} style={{ marginTop: '24px', marginBottom: '24px' }}>
        <div
          style={{
            display: 'flex',
            gap: '16px',
            overflow: 'hidden',
            width: '100%',
            maxWidth: '900px',
            padding: '20px 10px',
            borderRadius: '20px',
            justifyContent: 'center',
          }}
        >
          {Array.from({ length: carouselLength }).map((_, i) => (
            <Skeleton
              key={i}
              variant="rectangular"
              width={cardWidth}
              height={cardHeight}
              borderRadius={14}
              animation="pulse"
            />
          ))}
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={46}
          borderRadius={8}
          animation="pulse"
          style={{ maxWidth: '600px' }}
        />
      </div>
    </div>
  );
};

export default SkeletonLevelUp;
